import Swiper, {Controller, Navigation} from "swiper";

const Slider = (element: HTMLElement) =>
	new Swiper(element, {
		modules: [Navigation, Controller],
		slidesPerView: 1,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
	});

export default () => {
	const sliders: HTMLElement[] = Array.from(
		document.querySelectorAll(".block.home-hero.swiper")
	);

	if (!sliders) return;

	sliders.map((element: HTMLElement) => Slider(element));
};
